<div style="height: 96px" *ngIf="position === 'fixed'"></div>
<div class="box">
	<!-- <div style="height: 64px" *ngIf="firstTime"></div> -->
	<!-- <ng-content select="[terms]"></ng-content> -->
	<div class="btns">
		<ng-content></ng-content>
	</div>
</div>
